<template>
  <h1>---- {{ $t('quick_boking.lbl_not_found') }} -----</h1>
</template>
